import { connect, MapDispatchToProps, MapStateToProps } from "react-redux";

import { IAppState, NoneOwnProps } from "@multiweb/types/react";
import { createLoadTransitionHeaderAction } from "../actions";
import { getTransitionByIndex, isWorkflowReadOnly } from "../selectors";
import { TransitionComponent, TransitionComponentProps } from "./TransitionComponent";

type TransitionProps = Pick<TransitionComponentProps, "picassoInstanceKey" | "link">;

type StateProps = Pick<TransitionComponentProps, "transition" | "isWorkflowReadOnly">;

const mapStateToProps: MapStateToProps<StateProps, TransitionProps, IAppState> = (state, { picassoInstanceKey, link }) => ({
    transition: getTransitionByIndex(state, picassoInstanceKey, link.index),
    isWorkflowReadOnly: isWorkflowReadOnly(state, picassoInstanceKey),
});

type DispatchProps = Pick<TransitionComponentProps, "loadTransitionHeader">;

const mapDispatchToProps: MapDispatchToProps<DispatchProps, NoneOwnProps> = {
    loadTransitionHeader: createLoadTransitionHeaderAction,
};

export const Transition = connect(mapStateToProps, mapDispatchToProps)(TransitionComponent);
